import React from 'react'
import { Modal } from 'components'
import { useHistory } from 'react-router-dom'

type DownloadCSVPopupProps = {
  open: boolean
  onClose: () => void
  reportFileName: string
}

export const DownloadCSVPopup: React.FC<DownloadCSVPopupProps> = (props) => {
  const { open, onClose, reportFileName } = props
  const history = useHistory()

  return (
    <Modal
      title="The CSV report is being generated."
      maxWidth="xs"
      open={open}
      onClose={onClose}
      testId={`download-csv-popup`}
    >
      <div>
        To download the report please click{' '}
        <span
          className="underline italic text-blue-500 cursor-pointer"
          onClick={() => {
            history.push(`/supplier/reports${reportFileName ? `?reportFileName=${reportFileName}` : ''}`)
          }}
        >
          here
        </span>{' '}
        or visit on View Reports.
      </div>
    </Modal>
  )
}
